class ImagesiteScroll {
  constructor() {
    const imagesite = document.querySelector('.imagesite-container');
    if(!!imagesite){
      /*const isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
      var isFirefox = typeof InstallTrigger !== 'undefined';
      if(isMac){
        document.querySelector('body').classList.add('imagesite-background--mac');
      } else{
        document.querySelector('body').classList.add('imagesite-background--windows');
      }
      if(isFirefox){
        document.querySelector('body').classList.add('imagesite-background--firefox');
      }*/
      document.querySelector('body').classList.add('imagesite-background');

      const videoURL = document.querySelector('.js-imagesite-container-video').innerText;

      this.video = imagesite.querySelector('video');
      //this.video.querySelector('source').src = videoURL; 

      var source = document.createElement('source');
      source.setAttribute('src', videoURL);
      this.video.appendChild(source);

      this.video.addEventListener('loadedmetadata', (event) => {
        this.vLength = this.video.duration;
        this.cHeight = imagesite.offsetHeight;
        const bounding = imagesite.getBoundingClientRect();
        this.bTop = bounding.top;
        this.video.pause();
        this.video.removeAttribute("loop");
        this.scroller();
      });


    }
  }

  scrollFunction(e){
    if(window.scrollY - this.bTop < 0){
      //Before you scrolled to the video
      //this.video.currentTime = 0;
      this.video.style.bottom = 'auto';
      this.video.style.top = '20vh';
      this.video.style.position = 'absolute';
      this.video.play();
    } else if(window.scrollY - this.bTop > this.cHeight) {
      //After you passed the video
      this.video.style.position = 'absolute';
      this.video.style.bottom = 0;
      this.video.style.top = 'auto';
      //this.video.currentTime = this.vLength - 0.1;
      
    } else if(window.scrollY - this.bTop > this.cHeight - this.video.offsetHeight){
      this.video.style.position = 'absolute';
      this.video.style.bottom = 0;
      this.video.style.top = 'auto';
      //this.video.currentTime = this.calculateVideoPosition();
    } else{
      this.video.style.position = 'fixed';
      //this.video.currentTime = this.calculateVideoPosition();
    }
  }
    
  scroller(){
    window.addEventListener('scroll', (e) => { 
      this.scrollFunction(e);
    });
    window.addEventListener('touchmove', (e) => {
      this.scrollFunction(e);
    });
  }

  calculateVideoPosition(){
    return Math.round(this.vLength / this.cHeight * (window.scrollY - this.bTop));
  }

} export default ImagesiteScroll;
